export enum AnnouncementRoleScopeTypeKey {
  ALL = 'all',
  ALL_PROFESSIONS = 'all_professions',
  ALL_ESTATE_ROLES = 'all_estate_roles',
  SELECT = 'select'
}
